module.exports = __webpack_public_path__ + "img/asset-02.eb813f05.svg";